export const RecipeSchemaNameMaxLength = 30 // copy, to avoid circular dependency
